import * as React from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Image from "next/image";
import Coin from "../../assets/stcoin.png";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import ProductDetails from "./ProductDetails";
import { ApiService } from "@/app/services/AppService";
import { ResponseObject } from "@/app/classes/main";
import { getToken } from "@/app/services/HolderService";
import toast from "react-hot-toast";
interface StoreItemProps {
  item: any;
  conisDetails: any;
  handleAddToCartProducts: any;
}

const StoreItem: React.FC<StoreItemProps> = ({
  item,
  conisDetails,
  handleAddToCartProducts,
}) => {
  const title = item?.title;
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const matchingProduct = conisDetails?.productCartDetails?.find(
    (detail: any) => detail.product.id === item.id
  );
  const initialQuantity = matchingProduct ? matchingProduct?.quantity : 1;

  const [isClicked, setIsClicked] = React.useState(!!matchingProduct);
  const [value, setValue] = React.useState(initialQuantity);
  const [open, setOpen] = React.useState(false);
  const token = getToken();

  const apiService = new ApiService();

  const handleClickButton = async (e: any, item: any) => {
    e.stopPropagation();
    if (token) {
      setIsClicked(true);
      await handleAddToCartProducts(item, true);
    } else {
      toast.error("You are not Logged In", {
        duration: 5000,
        style: {
          padding: "16px",
        },
      });
    }
  };

  const handleValueDecrease = (e: any, item: any) => {
    e.stopPropagation();
    handleAddToCartProducts(item, false);
    if (value >= 2) {
      setValue(value - 1);
    } else if (value === 1) {
      setIsClicked(false);
    }
  };

  const handleValueIncrease = (e: any, item: any) => {
    e.stopPropagation();
    handleAddToCartProducts(item, true);
    setValue(value + 1);
  };

  const truncateText = (title: any, maxLength: any) => {
    const text = title.title;
    const lettersWithSpaces = text.split(" ").join(" ");
    const words = lettersWithSpaces.split(" ");
    let truncatedText = "";
    let currentLength = 0;

    for (let word of words) {
      if (currentLength + word.length > maxLength) {
        truncatedText += "...";
        break;
      }
      truncatedText += word + " ";
      currentLength += word.length + 1; // +1 for the space
    }

    return truncatedText.trim();
  };

  const handleViewProductDetails = () => {
    setOpen(true);
  };

  const addControlSx = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-evenly",
    background:
      "linear-gradient(135deg, rgba(223, 246, 232, 0.95) 0%, rgba(200, 239, 217, 0.85) 100%)",
    border: "1px solid rgba(31, 122, 77, 0.28)",
    borderRadius: "999px",
    color: "#123524",
    height: { xs: "30px", sm: "35px" },
    width: { xs: "80px", sm: "125px" },
  };

  const addButtonSx = {
    boxShadow: "none",
    textTransform: "capitalize" as const,
    minWidth: "10px",
    background:
      "linear-gradient(135deg, rgba(223, 246, 232, 0.95) 0%, rgba(200, 239, 217, 0.85) 100%)",
    border: "1px solid rgba(31, 122, 77, 0.28)",
    borderRadius: "999px",
    height: { xs: "30px", sm: "35px" },
    width: { xs: "80px", sm: "125px" },
    color: "#123524",
    "&:hover": {
      background:
        "linear-gradient(135deg, rgba(200, 239, 217, 1) 0%, rgba(174, 228, 198, 0.95) 100%)",
    },
  };

  return (
    <>
      <Card
        sx={{
          maxWidth: 340,
          maxHeight: 340,
          height: { xs: "280px", sm: "340px" },
          cursor: "pointer",
          margin: {
            xs: "4px",
            sm: "1rem 4px",
            md: "1rem 4px",
            lg: "1rem 4px",
            xl: "1rem auto",
          },
          width: "100%",
          border: "1px solid rgba(18, 53, 36, 0.1)",
          borderRadius: "16px",
          boxShadow: "0 8px 28px rgba(18, 53, 36, 0.08)",
          overflow: "hidden",
        }}
        onClick={handleViewProductDetails}
      >
        <CardMedia
          sx={{
            height: { xs: 150, sm: 200 },
            backgroundSize: "contain",
            transition: "transform 1s ease",
            "&:hover": {
              transform: "scale(1.05)",
            },
          }}
          image={item?.profileImage?.secureHttpPath ?? ""}
          title="Example"
        />
        <CardContent sx={{ padding: { xs: "0.5rem", sm: "0.5rem 1rem" } }}>
          <Typography
            variant="body2"
            sx={{
              color: "black",
              marginBottom: "5px",
              height: "3em",
              overflow: "hidden",
            }}
            component="div"
          >
            {truncateText({ title }, 80)}
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: "black", fontWeight: "600" }}
          >
            {item?.productQuantityDisplayName ?? ""}
          </Typography>
        </CardContent>
        <CardActions
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: { xs: "0.5rem", sm: "0.5rem 1rem 1rem" },
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "left",
              alignItems: "center",
            }}
          >
            <Image
              src={Coin}
              height={500}
              width={500}
              alt="coin"
              style={{
                width: isSmallScreen ? "1.5rem" : "2rem",
                height: isSmallScreen ? "1.5rem" : "2rem",
              }}
            />
            &nbsp;
            <Typography variant="body2" sx={{ fontWeight: "600" }}>
              {item?.salontymCoins.toLocaleString() ?? ""}
            </Typography>
          </Box>
          {isClicked ? (
            <Box
              onClick={(e) => e.stopPropagation()}
              sx={addControlSx}
            >
              <RemoveIcon
                onClick={(e) => handleValueDecrease(e, item)}
                sx={{ cursor: "pointer", fontSize: { xs: "16px", sm: "24px" } }}
              />
              <Typography
                variant="body1"
                sx={{ fontSize: { xs: "14px", sm: "16px" } }}
              >
                {value}
              </Typography>
              <AddIcon
                onClick={(e) => handleValueIncrease(e, item)}
                sx={{ cursor: "pointer", fontSize: { xs: "16px", sm: "24px" } }}
              />
            </Box>
          ) : (
            <Button
              variant="contained"
              sx={addButtonSx}
              onClick={(e) => handleClickButton(e, item)}
            >
              Add
            </Button>
          )}
        </CardActions>
      </Card>
      <ProductDetails
        open={open}
        close={() => setOpen(false)}
        handleClickButton={handleClickButton}
        handleValueIncrease={handleValueIncrease}
        handleValueDecrease={handleValueDecrease}
        value={value}
        isClicked={isClicked}
        item={item}
      />
    </>
  );
};

export default StoreItem;
